import React, { useEffect, useRef, useState } from "react";
import "./InputField.scss";
import { AppConfig } from "../../config";
import { auto } from "@popperjs/core";

export type Option = {
  name: string;
  value: string | number;
  checked?: Boolean;
};

type InputFieldProps = {
  label: string;
  name?: string;
  type: "text" | "number" | "textarea" | "select" | "multiselect" | "creatable";
  value?: any;
  options?: Option[];
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  error?: string;
  multiple?: boolean; // for multiselect
  onChange: (value: any) => void;
  onCreateOption?: (name: string) => void;
};

const InputField: React.FC<InputFieldProps> = ({
  label,
  name = "",
  type,
  value,
  options = [],
  required = false,
  disabled = false,
  placeholder = "",
  error,
  multiple = false,
  onChange,
  onCreateOption,
}) => {
  const [inputValue, setInputValue] = useState<any>("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState<Option[]>(options);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (["text", "number", "textarea"].includes(type)) {
      if (inputValue !== value) setInputValue(value ?? "");
    } else {
      if (inputValue !== value?.name) setInputValue(value?.name ?? "");
    }

    // else if (type !== "multiselect" && value?.name && inputValue !== value.name) {
    //   setInputValue(value.name);
    // } else if (type !== "select" && value?.name && inputValue !== value.name) {
    //   setInputValue(value.name);
    // }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const handleInputChange = (
  //   e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   const val = type === "number" ? Number(e.target.value) : e.target.value;
  //   setInputValue(val);

  //   if (["text", "number", "textarea"].includes(type)) {
  //     onChange(val);
  //   } else {
  //     setDropdownOpen(true);
  //   }

  //   setFilteredOptions(
  //     options.filter((opt) =>
  //       opt.name.toLowerCase().includes(String(e.target.value).toLowerCase())
  //     )
  //   );
  // };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const rawVal = e.target.value;

    // Allow empty string in input
    setInputValue(rawVal);

    if (["text", "textarea"].includes(type)) {
      onChange(rawVal);
    } else if (type === "number") {
      // Only convert to number if not empty and a valid number
      if (rawVal === "") {
        onChange(""); // or null, depending on your backend
      } else if (!isNaN(Number(rawVal))) {
        onChange(Number(rawVal));
      }
    } else {
      setDropdownOpen(true);
      setFilteredOptions(
        options.filter((opt) =>
          opt.name.toLowerCase().includes(rawVal.toLowerCase())
        )
      );
    }
  };

  const handleSelect = (opt: Option) => {
    if (type === "multiselect") {
      const exists = value?.some((v: Option) => v.value === opt.value);
      const newValue = exists
        ? value.filter((v: Option) => v.value !== opt.value)
        : [...(value || []), opt];
      onChange(newValue);
      setInputValue(""); // optional: clear input field after selecting
    } else {
      onChange(opt);
      setInputValue(opt.name);
      setDropdownOpen(false);
    }
  };

  const handleCreate = () => {
    if (onCreateOption && inputValue) {
      const newOpt: Option = {
        name: inputValue,
        value: inputValue.toLowerCase().replace(/\s+/g, "-"),
      };
      onCreateOption(inputValue);
      onChange(newOpt);
      setDropdownOpen(false);
    }
  };

  const showCreateOption =
    type === "creatable" &&
    inputValue &&
    !options.some((opt) => opt.name.toLowerCase() === inputValue.toLowerCase());

  // const renderInput = () => {
  //   // if (type === "textarea") {
  //   //   return (
  //   //     <textarea
  //   //       className="form-control border-0 px-0"
  //   //       value={inputValue}
  //   //       onChange={handleInputChange}
  //   //       onFocus={() => setDropdownOpen(!dropdownOpen)}
  //   //     />
  //   //   );
  //   // }

  //   return (
  //     <input
  //       id={name}
  //       name={name}
  //       style={disabled ? { color: "gray" } : { color: "black" }}
  //       type={type === "number" ? "number" : "text"}
  //       value={inputValue}
  //       disabled={disabled}
  //       // className={`border-0 px-0 ${
  //       //   disabled ? "form-control-disabled" : "form-control"
  //       // } `}
  //       className={`border-0 px-0 w-100`}
  //       required={required}
  //       onChange={handleInputChange}
  //       onFocus={() => {
  //         setFilteredOptions(options);
  //         setDropdownOpen(true);
  //       }}
  //     />
  //   );
  // };

  // const renderInput = () => {
  //   if (type === "multiselect") {
  //     return (
  //       <div
  //         className="d-flex flex-wrap align-items-center gap-1 w-100"
  //         onClick={() => {
  //           if (!disabled) setDropdownOpen(true);
  //         }}
  //         style={{
  //           minHeight: "38px",
  //           maxHeight: "120px",
  //           overflowY: "auto",
  //           cursor: disabled ? "not-allowed" : "text",
  //         }}
  //       >
  //         {(value || []).map((v: Option) => (
  //           <span
  //             key={v.value}
  //             className="badge bg-primary text-white d-flex align-items-center"
  //             style={{
  //               padding: "4px 8px",
  //               borderRadius: "12px",
  //               fontSize: "12px",
  //               whiteSpace: "nowrap",
  //               maxWidth: "100%",
  //             }}
  //           >
  //             {v.name}
  //             <span
  //               className="ms-1"
  //               onClick={(e) => {
  //                 e.stopPropagation();
  //                 handleSelect(v); // remove
  //               }}
  //               style={{
  //                 cursor: "pointer",
  //                 fontWeight: "bold",
  //                 paddingLeft: "4px",
  //               }}
  //             >
  //               &times;
  //             </span>
  //           </span>
  //         ))}

  //         <input
  //           type="text"
  //           className="border-0 flex-grow-1 px-0 bg-transparent"
  //           value={inputValue}
  //           placeholder={value?.length ? "" : placeholder}
  //           disabled={disabled}
  //           onChange={handleInputChange}
  //           onFocus={() => {
  //             setFilteredOptions(options);
  //             setDropdownOpen(true);
  //           }}
  //           style={{
  //             minWidth: "80px",
  //             outline: "none",
  //             fontSize: "14px",
  //             lineHeight: "20px",
  //           }}
  //         />
  //       </div>
  //     );
  //   }

  //   // Fallback for other input types
  //   return (
  //     <input
  //       id={name}
  //       name={name}
  //       style={disabled ? { color: "gray" } : { color: "black" }}
  //       type={type === "number" ? "number" : "text"}
  //       value={inputValue}
  //       disabled={disabled}
  //       className="border-0 px-0 w-100"
  //       required={required}
  //       onChange={handleInputChange}
  //       onFocus={() => {
  //         setFilteredOptions(options);
  //         setDropdownOpen(true);
  //       }}
  //     />
  //   );
  // };

  const renderInput = () => {
    if (type === "multiselect") {
      const selectedCount = (value || []).length;
      const collapseThreshold = 3; // max badges to show before collapsing
      const [collapsed, setCollapsed] = useState(true);

      return (
        <div
          className="d-flex flex-wrap align-items-center gap-1 w-100"
          onClick={() => {
            if (!disabled) setDropdownOpen(true);
          }}
          style={{
            minHeight: "38px",
            maxHeight: "120px",
            overflowY: "auto",
            cursor: disabled ? "not-allowed" : "text",
          }}
        >
          {(value || [])
            .slice(0, collapsed ? collapseThreshold : value.length)
            .map((v: Option) => (
              <span
                key={v.value}
                className="badge bg-primary text-white d-flex align-items-center"
                style={{
                  padding: "4px 8px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}
              >
                {v.name}
                <span
                  className="ms-1"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelect(v); // remove
                  }}
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                    paddingLeft: "4px",
                  }}
                >
                  &times;
                </span>
              </span>
            ))}

          {/* Show “+N more” toggle if collapsed and clear all */}
          {selectedCount > collapseThreshold && (
            <>
              <span
                className="badge bg-light text-dark"
                style={{
                  padding: "4px 8px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setCollapsed(!collapsed);
                }}
              >
                {collapsed
                  ? `+${selectedCount - collapseThreshold} more`
                  : `Show less`}
              </span>

              {/* ✅ Clear All Badge */}
              <span
                className="badge bg-danger text-white"
                style={{
                  padding: "4px 8px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  cursor: "pointer",
                  marginLeft: "4px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  onChange([]);
                  setInputValue("");
                }}
              >
                Clear All
              </span>
            </>
          )}

          <input
            type="text"
            className="border-0 flex-grow-1 px-0 bg-transparent"
            value={inputValue}
            placeholder={value?.length ? "" : placeholder}
            disabled={disabled}
            onChange={handleInputChange}
            onFocus={() => {
              setFilteredOptions(options);
              setDropdownOpen(true);
            }}
            style={{
              minWidth: "80px",
              outline: "none",
              fontSize: "14px",
              lineHeight: "20px",
            }}
          />
        </div>
      );
    }

    // Fallback input for non-multiselect
    return (
      <input
        id={name}
        name={name}
        style={disabled ? { color: "gray" } : { color: "black" }}
        type={type === "number" ? "number" : "text"}
        value={inputValue}
        disabled={disabled}
        className="border-0 px-0 w-100"
        required={required}
        onChange={handleInputChange}
        onFocus={() => {
          setFilteredOptions(options);
          setDropdownOpen(true);
        }}
      />
    );
  };

  return (
    <div className="dropdown mb-3" ref={ref}>
      <div
        className={`form-control radius-10 d-flex align-items-center ${
          disabled
            ? "custom-select-disabled"
            : error
            ? "custom-select-error"
            : "custom-select"
        }`}
        style={{ height: auto }}
      >
        {renderInput()}
        <span
          className={`floating-custom-label ${
            disabled ? "text-gray" : error ? "text-red" : "text-black"
          }`}
        >
          {label}
          {required && <span className="required-star"> *</span>}
        </span>
        {!disabled &&
          (type === "select" ||
            type === "multiselect" ||
            type === "creatable") && (
            <div
              className="ms-auto"
              onClick={() => setDropdownOpen((prev) => !disabled && !prev)}
            >
              <img
                src={
                  AppConfig.CDN_Media_url +
                  "b1b871802f6048caa74336bf068322cb.svg"
                }
                className="w-10px"
                alt="toggle"
              />
            </div>
          )}
      </div>

      {name != "strike_price_without_tax" &&
        name != "strike_price_with_tax" &&
        error && (
          <label htmlFor="" className="max-input fs-10px text-red mx-2 mt-2">
            {error}
          </label>
        )}

      {dropdownOpen &&
        (type === "select" || type === "creatable" ? (
          <ul className="dropdown-menu show w-100 mt-1">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt) => (
                <li key={opt?.value}>
                  <button
                    className="dropdown-item"
                    onClick={() => handleSelect(opt)}
                  >
                    {opt.name}
                  </button>
                </li>
              ))
            ) : showCreateOption ? (
              <li className="dropdown-item text-muted" onClick={handleCreate}>
                Create "{inputValue}"
              </li>
            ) : (
              <li>
                <button className="dropdown-item">No Options</button>
              </li>
            )}
          </ul>
        ) : (
          type === "multiselect" && (
            <ul className="dropdown-menu show w-100 mt-1">
              {/* {filteredOptions.length > 0 ? (
                filteredOptions
                  .filter((opt) => !value?.some((v: Option) => v.value === opt.value))
                  .map((opt) => (
                    <li key={opt?.value}>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          handleSelect(opt);
                        }}
                      >
                        {opt.name}
                      </button>
                    </li>
                  ))
              ) : (
                <li>
                  <button className="dropdown-item">No Options</button>
                </li>
              )} */}
              {(() => {
                const selectedValues = value || [];
                const unselectedOptions = filteredOptions.filter(
                  (opt) =>
                    !selectedValues.some((v: Option) => v.value === opt.value)
                );

                const allOptionsSelected = unselectedOptions.length === 0;

                return (
                  <>
                    {!allOptionsSelected && (
                      <li>
                        <button
                          className="dropdown-item text-primary fw-bold"
                          onClick={() => {
                            const newValue = [
                              ...selectedValues,
                              ...unselectedOptions,
                            ];
                            onChange(newValue);
                            setInputValue("");
                          }}
                        >
                          Select All
                        </button>
                      </li>
                    )}
                    {unselectedOptions.length > 0
                      ? unselectedOptions.map((opt) => (
                          <li key={opt?.value}>
                            <button
                              className="dropdown-item"
                              onClick={() => handleSelect(opt)}
                            >
                              {opt.name}
                            </button>
                          </li>
                        ))
                      : allOptionsSelected && (
                          <li>
                            <button className="dropdown-item" disabled>
                              No Options
                            </button>
                          </li>
                        )}
                  </>
                );
              })()}
            </ul>
          )
        ))}

      {/* {type === "multiselect" && value?.length > 0 && (
        <div className="mt-2 selected-values d-flex flex-wrap">
          {value.map((v: Option) => (
            <span
              key={v.value}
              className="badge bg-primary me-1 mb-1 d-flex align-items-center"
            >
              {v.name}
              <span
                className="ms-2 cursor-pointer"
                onClick={() => handleSelect(v)}
                style={{ fontWeight: "bold", cursor: "pointer" }}
              >
                &times;
              </span>
            </span>
          ))}
        </div>
      )} */}
    </div>
  );
};

export default InputField;
